import { useMemo, useState } from "react";
import { calculateNaviPartnerPricing, formatMoney } from "../../lib/meetupPricing";
import { Input } from "../ui/input";
import NaviPricingBreakdown from "./NaviPricingBreakdown";

export default function PartnerRevenueCalculator() {
  const [basePrice, setBasePrice] = useState(100);
  const [country, setCountry] = useState("barbados");
  const [partnerTier, setPartnerTier] = useState("standard");

  const pricing = useMemo(
    () => calculateNaviPartnerPricing({ desiredPayout: basePrice, country, partnerTier }),
    [basePrice, country, partnerTier]
  );

  return (
    <div className="rounded-[2rem] border border-orange-100 bg-white shadow-xl p-6">
      <div className="mb-5">
        <p className="text-sm uppercase tracking-[0.18em] text-orange-500 font-semibold">
          Revenue Calculator
        </p>
        <h3 className="text-2xl font-serif font-bold text-slate-900">
          Visible and profitable
        </h3>
        <p className="text-sm text-slate-500 mt-2">
          Show partners exactly how Mansion pricing stays transparent for the guest and profitable for the business.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-3 mb-5">
        <Input
          type="number"
          value={basePrice}
          onChange={(event) => setBasePrice(Number(event.target.value) || 0)}
          className="rounded-2xl"
          placeholder="You Keep"
        />
        <select
          value={country}
          onChange={(event) => setCountry(event.target.value)}
          className="rounded-2xl border border-slate-200 px-4 py-3 text-sm"
        >
          <option value="barbados">Barbados</option>
          <option value="jamaica">Jamaica</option>
          <option value="trinidad">Trinidad</option>
          <option value="bahamas">Bahamas</option>
        </select>
        <select
          value={partnerTier}
          onChange={(event) => setPartnerTier(event.target.value)}
          className="rounded-2xl border border-slate-200 px-4 py-3 text-sm"
        >
          <option value="standard">Standard partner (15%)</option>
          <option value="featured">Featured subscriber (12%)</option>
          <option value="pro">Business PRO (10%)</option>
        </select>
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        <div className="rounded-2xl bg-slate-950 text-white p-4">
          <p className="text-sm text-slate-300 mb-2">Guest sees</p>
          <p className="text-2xl font-bold">{formatMoney(pricing.totalPrice)}</p>
          <p className="text-xs text-slate-400 mt-2">Final price after VAT/GCT and DHC 15%.</p>
        </div>
        <div className="rounded-2xl bg-emerald-50 border border-emerald-100 p-4">
          <p className="text-sm text-emerald-700 mb-2">Business keeps</p>
          <p className="text-2xl font-bold text-slate-900">{formatMoney(pricing.businessPayout)}</p>
          <p className="text-xs text-slate-500 mt-2">
            Mansion gross ~{formatMoney(pricing.dhcGrossRevenue)} · VAT remitted{" "}
            {formatMoney(pricing.vatRemitted)}
          </p>
        </div>
      </div>

      <NaviPricingBreakdown pricing={pricing} />

      <div className="mt-5 rounded-2xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-600">
        If you want to keep <strong>{formatMoney(pricing.businessPayout)}</strong>, your guest pays{" "}
        <strong>{formatMoney(pricing.totalPrice)}</strong>. VAT is remitted to government; Mansion earns
        platform, booking, and processing recovery fees — not the VAT line.
      </div>
    </div>
  );
}
